import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function notDefaultValidator(defaultValue: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value == defaultValue) {
            return { notDefault: true };
        }
        return null;
    };
}